// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorPage_ErrorContainer__2GS80","ErrorImg":"ErrorPage_ErrorImg__2tzyS","Error":"ErrorPage_Error__2-g9Y","Return":"ErrorPage_Return__LrVDB"};